import React from 'react';
import {Container, SubHeading, Heading, Pane ,Content, Text, Line,Logo, Frame,TextHeading} from './styles/features';

export default function Features({children, ...restProps}) {
  return (<Container {...restProps}> {children} </Container>)
}

Features.SubHeading = function FeaturesSubHeading({children, ...restProps}){
  return <SubHeading {...restProps}>{children}</SubHeading>
}

Features.Heading = function FeaturesHeading({children, ...restProps}){
  return <Heading {...restProps}>{children}</Heading>
}

Features.TextHeading = function FeaturesTextHeading({children, ...restProps}){
  return <TextHeading {...restProps}>{children}</TextHeading>
}

Features.Logo = function FeaturesLogo({children, ...restProps}){
  return <Logo {...restProps} />
}

Features.Pane = function FeaturePane({children, ...restProps}){
  return <Pane {...restProps}>{children}</Pane>
}

Features.Content = function FeaturesContent({children, ...restProps}){
  return <Content {...restProps}>{children}</Content>
}

Features.Text = function FeaturesText({children, ...restProps}){
  return <Text {...restProps}>{children}</Text>
}

Features.Frame = function FreaturesFrame({children, ...restProps}){
  return <Frame {...restProps}>{children}</Frame>
}

Features.Line = function FeaturesLine({children, ...restProps}){
  return <Line {...restProps}>{children}</Line>
}